(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  const optimizeHomepageVideos = () => {
    if (!mobileQuery.matches || !document.body.classList.contains('template-index')) return;

    document.documentElement.classList.add('rvx-mobile-optimized');

    const videos = document.querySelectorAll('.rvx-home-hero__video, .rvx-ct__video, .rvx-vf__video');
    videos.forEach((video) => {
      video.preload = 'metadata';
      video.playsInline = true;

      if (reduceMotionQuery.matches || connection?.saveData) {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }

      if (!('IntersectionObserver' in window) || video.dataset.rvxMobileObserved === 'true') return;
      video.dataset.rvxMobileObserved = 'true';

      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          const promise = video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(() => {});
        } else {
          video.pause();
        }
      }, { rootMargin: '150px 0px', threshold: 0.01 });

      observer.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizeHomepageVideos, { once: true });
  } else {
    optimizeHomepageVideos();
  }

  document.addEventListener('shopify:section:load', optimizeHomepageVideos);
})();
